import { setIsAdmin, setUserName, SET_IS_ADMIN, useAppContext } from "../../context/appContext";
import LogoBig from "../../components/Logo/LogoBig";
import { StyledBasedOn } from "../../styles/BasedOn";
import { StyledDescription, StyledHeader, StyledLogin, StyledFooter, StyledForm } from "../../styles/StyledLoginPage";
import { Button } from "../../components/Button";
import LoginIcon from "../../assets/img/icons/login.svg";
import AuthSerivce from "../../service/AuthSerivce";
import { useState } from "react";
import { Error } from "../../components/Error";
import { userLogin, userUnits } from "../../context/appContext";
import { getUnitList } from "../../api/organization-unit/organization-unit";
import { getUserProfile } from "../../api/user/profile";
import useAuth from "../../hooks/useAuth";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

export default function Login() {
	const { dispatch } = useAppContext();
	const { axiosPrivate } = useAxiosPrivate();
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [error, setError] = useState(false);
	const { setAuth } = useAuth();

	const handleLogin = async (e) => {
		e.preventDefault();

		const response = await AuthSerivce.login(username, password);
		if (response?.status === 200) {
			setAuth({ ...response.data, date: new Date() });
			setError(false);
			const units = await getUnitList(axiosPrivate);
			const profile = await getUserProfile(axiosPrivate);
			dispatch(userUnits(units));
			dispatch(userLogin(true));
			dispatch(setIsAdmin(profile.isAdmin));
			dispatch(setUserName(profile.firstName + " " + profile.lastName));
		} else {
			setError(response);
		}
	};
	return (
		<StyledLogin>
			<div className="inner">
				<StyledHeader>
					<LogoBig></LogoBig>
					<StyledBasedOn>BasedOn</StyledBasedOn>
					<StyledDescription>Let's get started now!</StyledDescription>
				</StyledHeader>
				<StyledForm>
					<label htmlFor="username">Login</label>
					<input type="text" name="username" aria-label="username" onChange={(e) => setUsername(e.target.value)}></input>
					<label htmlFor="password">Password</label>
					<input type="password" name="password" aria-label="password" onChange={(e) => setPassword(e.target.value)} />
					{error && <Error>{error?.message}</Error>}
					{/* <Link to={"/reset-password"}>Forgot password?</Link> */}
					<Button icon={LoginIcon} onClick={handleLogin} alabel="login">
						Log in
					</Button>
				</StyledForm>
				<StyledFooter>
					<p>
						Don't have an account?<br></br> Contact our <a href="mailto:faramarz.agahi@gmail.com">Tech Support Team </a>
						to setup your account.
					</p>
				</StyledFooter>
			</div>
		</StyledLogin>
	);
}
